import { addModal } from 'weblite-web-modal-viewer'
import { HowToSyncIosContactsModal } from '$comp/modals/how-to-sync-ios-contacts/how-to-sync-ios-contacts-modal'

const COMPONENT_ID = 'howToSyncIOSContactsModal'

export const showHowToSyncIOSContactsModal = () =>
  addModal({ id: COMPONENT_ID, props: {} })

export default {
  [COMPONENT_ID]: {
    Component: HowToSyncIosContactsModal,
  },
}
